import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import { MdControlPoint, MdDelete, MdKeyboardDoubleArrowLeft, MdKeyboardDoubleArrowRight } from "react-icons/md";
import Response_Processing from "../../../../src/layout/Others/Response_Processing";
import { getItemToken } from "../../../Utils/localStorageUtils";
import AdminDeleteModal from "../../../components/CommonComponents/AdminDeleteModal";
import MessageBox from "../../../components/CommonComponents/MessageBox";
import AdminCustomInput from "../../../components/CommonComponents/AdminCustomInput";
import AdminCustomButton from "../../../components/CommonComponents/AdminCustomButton";
import { toast } from "react-toastify";
import MessageLabel from "../../../components/CommonComponents/MessageLabel";
import AdminHeader from "../../../components/CommonComponents/AdminHeader";
import NoRecordTable from "../../../components/CommonComponents/NoRecordTable";
import { IconDeleteFigma, IconEditFigma } from "../../../Assets/MyIcons";
import { FaEllipsisVertical } from "react-icons/fa6";
import { RxReload } from "react-icons/rx";
import { statusActiveFormatterDevices } from "../../../components/CommonMethod/CommonBoostrapFormatter";

function Devices() {
  const baseURL = process.env.REACT_APP_Baseurl
  const userAccessToken = getItemToken('access_token');
  const labelSource = 'devices-setting'

  const deleteApi = `${baseURL}/admin/devices/multi-delete`
  const getApi = `${baseURL}/admin/devices/index`
  const labelApi = `${baseURL}/admin/Label-Management/list-source?source=${labelSource}`
  const addApi = `${baseURL}/admin/devices/store`
  const editApi = `${baseURL}/admin/devices/edit`
  const updateApi = `${baseURL}/admin/devices/update`


  const [apiData, setApiData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showOverlay, setShowOverlay] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [selectAll, setSelectAll] = useState(false);
  const [modelClose, setModelClose] = useState(false);
  const [itemToDelete, setItemToDelete] = useState([]);
  const [withOutRefresh, setWithoutRefresh] = useState(false)
  const [labelDisplay, setLabelDisplay] = useState([]);
  const [formDataError, setFormDataError] = useState({})
  const [modelCloseAdd, setModelCloseAdd] = useState(false);

  const combinedRef = useRef({
    devices_name: "",
  });

  const [formData, setFormData] = useState({
    devices_name: "",
  })

  const handleInput = (e) => {
    const { name, value, type } = e.target;
    if (type === 'text') {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
      setFormDataError((prev) => ({
        ...prev,
        [name]: '',
      }));
    }
  };

  const closeModal = () => {
    setModelClose(!closeModal);
    setShowModal(false);
    setItemToDelete([])
  };

  const reloadAction = () => {
    setWithoutRefresh(prev => !prev)
  }

  const openModal = () => {
    setModelClose(true);
  };

  const handleCloseEditModal = () => {
    setModelCloseAdd(!modelCloseAdd)
    setFormData((prev) => ({ devices_name: "" }))
    setFormDataError((prev) => ({ devices_name: "" }))
  }

  const singleDelete = (id) => {
    setModelClose(true);
    setItemToDelete([id]);
  };

  const handleDeletedata = () => {
    handleConfirmDelete();
    closeModal();
  };

  const handleAll = () => {
    setSelectAll(!selectAll);
    setItemToDelete(selectAll ? [] : filteredData?.map((item) => item?.id));
  };

  const handleFilterChange = (data) => {
    setFilteredData(data);
  };

  const columns = [
    {
      dataField: "devices_name",
      text: "Devices",
      formatter: (cell) => {
        const devices = cell?.length > 20 ? `${cell.slice(0, 20)}...` : cell;
        return <span title={cell}>{devices}</span>;
      },
    },
    {
      dataField: "devices_type",
      text: "Devices Type",
      formatter: (cell) => {
        const devices = cell?.length > 20 ? `${cell.slice(0, 20)}...` : cell;
        return <span title={cell}>{devices?.toUpperCase()}</span>;
      },
    },
    {
      dataField: "active",
      text: "Status",
      sort: true,
      formatter: (cell, row) => statusActiveFormatterDevices(cell, row),
    },
    {
      dataField: "ACTIONS",
      text: "Actions",
      formatter: (cell, row) =>
        <div className="editdropdown ">
          <span className="editdropdown-button">
            <FaEllipsisVertical className="theme-text-color" />
          </span>
          <div className="editdropdown-menu theme-bg-color">
            <div onClick={() => handleEdit(row?.id)} className="commonActionPadding theme-bg-color"  >
              <IconEditFigma styled={{ width: "20px", height: "20px" }} />
              <MessageBox text="Edit" classname='ms-2 theme-text-color'></MessageBox>
            </div>
            {![1, 2, 3, 4, 5, 6, 7, 8, 9].includes(row?.id) && (
              <div onClick={() => singleDelete(row?.id)} className="commonActionPadding theme-bg-color"  >
                <IconDeleteFigma styled={{ width: "20px", height: "20px" }} />
                <MessageBox text="Delete" classname='ms-2 theme-text-color'></MessageBox>
              </div>
            )}
          </div>
        </div>,
    },
  ];

  const options = {
    pageStartIndex: 1,
    paginationSize: 4,
    sizePerPage: 10,
    nextPageText: "Next",
    prePageText: "Prev",
    firstPageText: <MdKeyboardDoubleArrowLeft />,
    lastPageText: <MdKeyboardDoubleArrowRight />,
    showTotal: true,
    alwaysShowAllBtns: true,
    sizePerPageList: [{
      text: '5', value: 5
    }, {
      text: '10', value: 10
    }, {
      text: 'All', value: Number(filteredData?.length)
    }]
  };
  const blockedIds = [1, 2, 3, 4, 5, 6, 7, 8, 9];


  const rowClasses = (row) => {
    return blockedIds.includes(row.id) ? 'hide-checkbox-row' : '';
  };

  const selectRow = {
    mode: "checkbox",
    onSelect: (row, isSelect) => {
      if (!row) return;

      if (isSelect) {
        setItemToDelete([...itemToDelete, row.id]);
      } else {
        setItemToDelete(itemToDelete.filter((id) => id !== row.id));
      }
    },
    onSelectAll: (isSelect, rows) => {
      if (isSelect) {
        const allIds = rows
          .filter((r) => !blockedIds.includes(r.id))
          .map((r) => r.id);
        setItemToDelete(allIds);
      } else {
        setItemToDelete([]);
      }
    },
    selected: itemToDelete,
    style: { width: '30px' },
    selectionHeaderRenderer: ({ mode, checked }) => (
      <div>
        <input type="checkbox" checked={checked} onChange={() => { }} />
      </div>
    ),
  };

  const fetchData = async () => {
    try {
      const response = await axios.get(`${getApi}`, { headers: userAccessToken });
      const result = response?.data?.devices;
      setApiData(result);
      setFilteredData(result);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoading(false);
    }
  };

  const handleEdit = async (id) => {
    try {
      const response = await axios.get(`${editApi}/${id}`, { headers: userAccessToken });
      const result = response?.data;
      if (result?.status) {
        setFormData(result?.device);
        setModelCloseAdd(true);
      }
      setLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoading(false);
    }
  };

  const handleConfirmDelete = async () => {
    setShowOverlay(true);
    try {
      const response = await axios.delete(`${deleteApi}`, {
        headers: userAccessToken,
        data: { id: [...itemToDelete] },
      });

      const result = response?.data;
      if (result?.status) {
        setWithoutRefresh(!withOutRefresh);
        toast.success(result?.message);
        setShowOverlay(false);
        setItemToDelete([])
      }
      else {
        toast.error(result?.message);
        setShowOverlay(false);
      }
    } catch (err) {
      var errorMessage = err?.response?.data?.message;
      toast.error(errorMessage);
      setShowOverlay(false);
    }
  };

  const labelFetch = async () => {
    try {
      setShowOverlay(true)
      const response = await axios.get(`${labelApi}`, { headers: userAccessToken });
      const result = response?.data?.label_management
      setLabelDisplay(result)
      setShowOverlay(false)
    }
    catch (err) {
      setShowOverlay(false)
      toast.error(err.response.data.message)

    }
  }

  const handleStore = async () => {
    let formIsValid = true;
    let findApi = !formData?.id ? addApi : `${updateApi}`
    if (!formData?.devices_name) {
      setFormDataError((prevFormData) => ({
        ...prevFormData,
        devices_name: "Device Name cannot be empty.",
      }));
      combinedRef.current['devices_name'].focus();
      formIsValid = false;
      return;
    }
    if (formData?.devices_name.length > 100) {
      setFormDataError((prevFormData) => ({
        ...prevFormData,
        devices_name: "Device Name must not exceed 100 characters.",
      }));
      combinedRef.current['devices_name'].focus();
      formIsValid = false;
      return;
    }
    if (formIsValid) {
      setShowOverlay(true);
      try {
        const formDataAdd = {};
        for (const key in formData) {
          if (["devices_name"].includes(key)) {
            formDataAdd[key] = formData[key]
          }
        }
        if (formData?.id) {
          formDataAdd["device_id"] = formData?.id
        }

        const response = await axios.post(findApi, formDataAdd, { headers: userAccessToken });
        const result = response?.data;
        if (result?.status) {
          setShowOverlay(false);
          setWithoutRefresh(!withOutRefresh)
          toast.success(result?.message)
          setModelCloseAdd(false);
          setFormData((prev) => ({
            devices_name: ""
          }))
        }

      }
      catch (err) {
        setShowOverlay(false);
        const errorMessage = err?.response?.data?.message
        toast.error(errorMessage)
      }
    }
  }


  useEffect(async () => {
    await fetchData();
    await labelFetch()
  }, [withOutRefresh]);

  console.log(itemToDelete, 'itemToDelete------');

  return (
    <>
      {showOverlay && <Response_Processing />}
      {modelClose && <AdminDeleteModal modelClose={modelClose} deleteClose={closeModal} deleteAction={handleDeletedata} buttonText={itemToDelete?.length} />}
      <div className="d-flex align-items-center flex-wrap pb-3 ">
        <div className="col-md-6 col-12 ">
          <h4 className="admin-title mb-0 theme-text-color text-md-start"> <MessageBox text={labelDisplay?.[0]?.title} classname="theme-text-color" />
            {apiData?.length && <span className="admin-sub-title theme-text-color ms-2 ">( {apiData?.length} <MessageBox text='results found' classname="theme-text-color" />   )</span>}</h4>
        </div>
        {/* <div className="col-md-6 col-12 d-flex align-items-center justify-content-end mt-3 mt-sm-0" >
          {itemToDelete?.length > 0 && (
            <button className="warningColorBg p-2 rounded-2 d-inline-flex align-items-center " onClick={() => openModal()}>
              <MdDelete className="exportIcon me-1" fill="#fff" />
              <MessageBox text='Delete' classname='admin-button-text ' />
            </button>
          )}
          <button type="button" onClick={() => setModelCloseAdd(!modelCloseAdd)} className="admin-title ms-3 rounded-2 d-inline-flex align-items-center bg-primary text-decoration-hover  py-2 px-3"    >
            <MdControlPoint className="me-2 exportIcon text-white" style={{ width: "22px", height: "22px" }} /> <MessageBox classname="admin-button-text text-white" text={labelDisplay?.[1]?.title} />
          </button>
        </div> */}
      </div>

      <div className={`modal packageModel fade ${modelCloseAdd && "d-block show"}`} id="devices" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true"  >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <MessageLabel text={!formData?.id ? labelDisplay?.[2]?.title : labelDisplay?.[5]?.title} />
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={() => handleCloseEditModal()} ></button>
            </div>
            <div className="modal-body">
              <MessageLabel text={labelDisplay?.[3]?.title} className="mandatorySimple" />
              <AdminCustomInput type="text" name="devices_name" value={formData?.devices_name} onChange={handleInput} placeHolder="Devices name" ref={(el) => (combinedRef.current.devices_name = el)} error={formDataError?.devices_name} />
            </div>
            <div className="modal-footer">
              <AdminCustomButton className='px-3 py-1 me-3 me-md-0 ms-md-auto' saveMethod={handleStore} saveText={!formData?.id ? labelDisplay?.[1]?.title : labelDisplay?.[4]?.title} />
            </div>
          </div>
        </div>
      </div>

      <div className="theme-bg-color p-3 rounded-2 bootstrapTable  multi-delete-width" >
        <AdminHeader hideExport searchMethod={handleFilterChange} reduceData={filteredData} originalData={apiData} fileName={"devices"} reload={true} reloadAction={reloadAction} loading={loading} customDevices />
        <BootstrapTable keyField="id" pagination={paginationFactory(options)} columns={columns} data={filteredData} className="no-border-table theme-text-color " rowClasses={rowClasses} noDataIndication={<NoRecordTable result={filteredData?.length} loader={loading} />} hover headerClasses="videoWidth" selectRow={selectRow} selectAll={selectAll} />
      </div>
    </>
  );
}

export default Devices;